<ng-template #content>
  <ng-container *ngIf="isOpen && showLoadingOverlay" [ngTemplateOutlet]="modalLoadingOverlay"></ng-container>
  <div
    class="modal-header"
    [ngClass]="{
      'd-block': hasHeader,
      'd-none d-md-block': !hasHeader
    }"
  >
    <div class="container-fluid mb-0">
      <div class="row">
        <div class="col-24">
          <div class="row clearfix flex-nowrap">
            <div class="col bl-h-5 d-flex align-items-center modal-headline-col">
              <div class="content-box pe-0" [ngClass]="{ 'pe-3 pe-md-0': !this.isSmallModal }">
                <h1
                  class="modal-title heading-md text-uppercase text-red my-0 py-0"
                  id="shrd-uic-modal-title-{{ modalId }}"
                >
                  {{ title }}
                </h1>
              </div>
            </div>
            <div
              class="col-auto d-md-flex align-items-center"
              [ngClass]="{ 'd-flex': this.isSmallModal, 'd-none': !this.isSmallModal }"
            >
              <div class="content-box px-0">
                <button
                  class="my-0 btn-close float-end"
                  (click)="dismissAll()"
                  shrdUicButton
                  type="button"
                  variant="tertiaryMinorBorderless"
                  [attr.title]="closeText"
                  [disabled]="closeDisabled"
                >
                  <shrd-uic-svg-icon icon="cross" size="small" [inheritColor]="true"></shrd-uic-svg-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-sub-header" *ngIf="subHeaderRef">
    <ng-container *ngIf="isOpen" [ngTemplateOutlet]="subHeaderRef"></ng-container>
  </div>

  <ng-container *ngIf="scrollbarEnabled; else noScrollingBody">
    <div class="modal-body sticky-top-root d-flex flex-column">
      <div
        shrdUicScrollbar
        shrdUicFloatingContainer
        class="js-scroll-container h-100"
        [scrollContentRef]="scrollContent"
        [initialScrollTo]="scrollToTargetSelector"
        [scrollBarVerticalRef]="verticalScrollbar"
        [triggerGlobalScroll]="true"
      >
        <div #scrollContent class="d-flex flex-column min-h-100">
          <ng-container *ngIf="isOpen && bodyRef" [ngTemplateOutlet]="bodyRef"></ng-container>
        </div>
      </div>
      <shrd-uic-scrollbar #verticalScrollbar></shrd-uic-scrollbar>
    </div>
  </ng-container>
  <ng-template #noScrollingBody>
    <div class="modal-body sticky-top-root d-flex" shrdUicFloatingContainer>
      <div class="flex-grow-1">
        <ng-container *ngIf="isOpen && bodyRef" [ngTemplateOutlet]="bodyRef"></ng-container>
      </div>
    </div>
  </ng-template>
  <div class="modal-footer">
    <ng-container *ngIf="isOpen && footerRef; else noFooterMobile" [ngTemplateOutlet]="footerRef"></ng-container>
  </div>
</ng-template>

<ng-template #noFooterMobile>
  <shrd-uic-smartbar [isFixed]="false" class="d-md-none">
    <div class="smartbar-column-left">
      <div class="content-box content-box-tertiary-left">
        <button shrdUicButton variant="tertiaryMinorBorderless" (click)="dismissAll()" [title]="closeText">
          <shrd-uic-svg-icon icon="arrow-left"></shrd-uic-svg-icon>
        </button>
      </div>
    </div>
  </shrd-uic-smartbar>
</ng-template>
